import { useEffect } from 'react';

import { DEFAULT_REACT_QUERY_CACHE_TIME } from 'Config/reactQueryConfig';
import type { ListPositionPages } from 'Stores/VehicleListPositionStore/VehicleListPositionStore';
import { useGetTimeSinceListPositionCache } from 'Stores/VehicleListPositionStore/VehicleListPositionStore';

import { useClearVehicleListCache } from './useClearVehicleListCache';

export const useVehicleListCache = (page: ListPositionPages): void => {
	const getTimeSinceListPositionCache = useGetTimeSinceListPositionCache();
	const timeSinceListPositionCache = getTimeSinceListPositionCache(page);
	const { clearAllVehicleListCache } = useClearVehicleListCache();

	useEffect(() => {
		window.addEventListener('beforeunload', clearAllVehicleListCache);
		return () => {
			window.removeEventListener('beforeunload', clearAllVehicleListCache);
		};
	}, [clearAllVehicleListCache]);

	useEffect(() => {
		if (timeSinceListPositionCache > DEFAULT_REACT_QUERY_CACHE_TIME) {
			clearAllVehicleListCache();
		}
	}, [timeSinceListPositionCache, clearAllVehicleListCache]);
};
